export const INACTIVE_CATEGORY_OPTIONS = [
  "Onboarding",
  "Temporarily Closed",
  "On Hold / Sale Stalled",
  "Just Delivery Locations",
];

export const SALESFORCE_ID_LENGTH = 18;
export const SALESFORCE_ID_PREFIX = "001";

// Display Names and Sales Tax both duplicated sections Restaurant Details already owns
// (Display and Contact tab, Tax and Timezone tab) - moved here rather than ported, following
// Account Settings' own MovedSettingsCard/MOVED_CARDS precedent for the same situation.
export const MOVED_CARDS = [
  {
    key: "display-names",
    title: "Display Names",
    message: "Name for Patrons, Name for Owners, and Name for Admins have moved.",
    linkText: "Go to Restaurant Details",
    url: "/restaurant-details",
  },
  {
    key: "sales-tax",
    title: "Sales Tax",
    message: "Sales tax settings have moved.",
    linkText: "Go to Restaurant Details",
    url: "/restaurant-details",
  },
];
